// extracted by mini-css-extract-plugin
export var attachmentContainer = "_mz-0";
export var fileList = "_mz-2";
export var removeFileButton = "_mz-1";